<template>
	<div full-height>
		<div class="display_wrapper" id="non-printable">

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text" :class="{'two-line-title':offsetTop>=36}">
			    	Stock Journal
			    	<div class="toolbar-subtitle" v-if="displayData && offsetTop>=36">
			    		<div class="subtitle-text dark-opacity-color">
			    			{{displayData.mergeTransactionNumber}}
			    		</div>
			    	</div>
			    </v-toolbar-title>

			    <v-spacer></v-spacer>

			    <!-- <v-btn round-borders outline @click="fn_edit" v-if="displayData && displayData.status==1">edit</v-btn> -->

			    <!-- <v-btn icon @click="fn_getBottomMenu">
			      <v-icon>more_vert</v-icon>
			    </v-btn> -->

			    <v-btn icon @click="fn_preview" v-if="displayData">
			    	<!-- <v-icon>remove_red_eye</v-icon> -->
			    	<img src="../../../../assets/icon_preview.svg" alt="preview_icon"></img>
			    </v-btn>

			    <v-btn icon @click="fn_edit" v-if="displayData && displayData.status==1">
			    	<v-icon>edit</v-icon>
			    </v-btn>
			</v-toolbar>

			<div full-height overflow-scroll grey-back class="display hasToolbar hasBigFooterWithExtention" v-scroll="onScrollTransactionForm">

				<v-alert :value="displayData && displayData.status==0" type="warning" transition="slide-y-transition">
					<span>This transaction has been cancelled!</span>
				</v-alert>

				<v-list nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title>{{displayData.mergeTransactionNumber}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<!-- <v-divider></v-divider> -->

				
				<v-list auto-height-tile nopadding margin-top-ten>

					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Particulars</v-list-tile-title>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<div v-for="(item, index) in displayData.transactionProducts" :key="index">
						<v-list-tile class="right-subtitle-tile custom-action-tile">
						    <v-list-tile-content>

						      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      	<v-list-tile-sub-title class="mb-1">

						      		<div>{{item.transactionProductMode ? 'Excess' : 'Short'}}</div>

						      		<div v-for="(vItem, vIndex) in item.variants" :key="vIndex" v-if="vItem.qty">
						      			&#8377; {{$root.numberToLocale(item.rate)}} X {{vItem.qty}} {{vItem.unitName}}
						      		</div>

						      		<!-- <span class="right_subtitle">&#8377; {{$root.numberToLocale(item.amount)}}</span> -->
						      		
						   		</v-list-tile-sub-title>
						      <v-list-tile-sub-title v-if="$root.TransactionSettings.mrpWiseStock">
						      	<span>MRP: <b>{{$root.numberToLocale(item.mrp)}}</b></span>
						      </v-list-tile-sub-title>
						    </v-list-tile-content>	

						    <v-list-tile-action>
						    	<div>&#8377; {{$root.numberToLocale(item.amount)}}</div>
						    </v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="displayData.transactionProducts.length-1 != index"></v-divider>

					</div>
				</v-list>

			    <div v-if="displayData.notes" class="margin-top-ten">
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<v-card flat class="note-card">
					  <v-card-text font16 v-html="displayData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</div>

				<v-footer white-background class="invoice-footer-actions">

					<v-layout grid wrap text-xs-center>
						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('sharewhatsapp')">
							<div right-border>
								<div style="height:26px"><img src="../../../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
						    	<div font11 class="font-weight-bold">Send</div>
							</div>	
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('share')">
						    <div right-border>
						    	<div><v-icon>share</v-icon></div>
						    	<div font11 class="font-weight-bold">Share</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('print')">
						    <div right-border>
						    	<div><v-icon>print</v-icon></div>
						    	<div font11 class="font-weight-bold">Print</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('pdf')">
						    <div right-border>
						    	<div><v-icon>vertical_align_bottom</v-icon></div>
						    	<div font11 class="font-weight-bold">Download</div>
						    </div>
						</v-flex>

						<!-- <v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_preview">
						    <div right-border>
						    	<div><v-icon>remove_red_eye</v-icon></div>
						    	<div class="font-weight-bold">Preview</div>
						    </div>
						</v-flex> -->

						<!-- <v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_getBottomMenu">
						    <div>
						    	<div><v-icon>more_horiz</v-icon></div>
						    	<div class="font-weight-bold">More</div>
						    </div>
						</v-flex> -->
					</v-layout>

					<div v-ripple class="pb-2 pt-2" center-align style="width:20%" white-background @click="fn_getBottomMenu">
						<div><v-icon>more_horiz</v-icon></div>
						<div font11 class="font-weight-bold">More</div>
		            </div>
					
				</v-footer>

			</div>

			<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" :header="confirmationDialogHeader" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true'></dialog-confirmation>
			
			<v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>
		</div>

		<div id="printable" full-width>
			<print-template ref="ref_printTemplate" :data="printData" v-if="printData!=null"></print-template>
		</div>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

		<v-snackbar v-model="snackbarOpenFile">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;

import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import printTemplate from '../../../invoice_templates/invoices/template201'

import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{},
				toolbarTitle:"Stock Journal",
				selectedNatureValue:null,
				snackbar:false,
				snackbar_msg:null,
				actionType:null,
				confirmationDialogHeader:null,
				printData:null
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'print-template': printTemplate
		},
		methods:{

			// fn_printData: function(){
			// 	this.fn_getPrintData();
			// 	AndroidRoutingTest.print();
			// },

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_preview: function(){
				this.fn_previewInvoice(true, "inventory", 'sj');
			},

			fn_bindInvoiceTemplate: function(type){

				if(this.disableAction){
					return;
				}

				this.disableAction = true;

				let self = this;
				setTimeout(function(){
					self.disableAction = false;
				},500);

				if(type=='sharewhatsapp'){
					this.fn_shareInvoice('sharewhatsapp');
				}
				else if(type=='print'){
					this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'print');
				}
				else if(type=='pdf'){
					this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'pdf');
				}
				else if(type=='share'){
					this.fn_shareInvoice('share');
				}
			},

			fn_shareInvoice: function(type){
				let shareObj = {};
				// shareObj.shareType = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? 'ShareOnWhatsApp' : 'Share';
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				shareObj.subject = "Stock Journal Details";
				shareObj.textMessage = this.$tShare('share.stockJournalMessage', {
					date: this.$moment(this.displayData.createdDate).format('DD-MMM-YYYY'),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				this.fn_getPrintData('StockJournalPrintData', this.displayData.transactionId, 'pdf', shareObj);
			},

			fn_callCancelTransaction: function(paramObj){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;

				let self = this;
				if(paramObj.type=='cancel'){
					this.fn_cancelTransaction(this.displayData.transactionId, this.displayData.transactionListId);	
				}
				else{
					let transactionNumber = this.displayData.mergeTransactionNumber;
					this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
						if(status){
							// self.snackbar = true;
							// self.snackbar = '#'+transactionNumber+ ' deleted parmanently!.';
							self.showToast('#'+transactionNumber+ ' deleted parmanently')
							self.$router.go(-1);
						}
						else{
							// self.snackbar = true;
							// self.snackbar = 'Something went wrong. Try again!.';	
							self.showToast("Something went wrong. Try again");
						}
					});
				}
			},

			fn_comingSoon: function () {
				// this.snackbar_msg = "Coming Soon..";
				// this.snackbar = true;
				this.showToast("Coming Soon...");
			},

			fn_getData: function (type, itemId) {
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.displayData = JSON.parse(response);
							self.displayData.transactionProducts.forEach(function (item) {
								item.transactionProductMode = item.variants[0].transactionProductMode;
								self.fn_getGroupTotal(item);
							})
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getGroupTotal: function (tp) {
				let total = 0;
				tp.variants.forEach(function (item) {
					total += item.amount;
				});
				tp.amount = total;
			},

			fn_getBottomMenu: function (tagId) {

				var bottomMenu = {"BottomMenu": [menuItem.cancelTransaction, menuItem.delete]};

				this.displayData.status==0 ? bottomMenu = {"BottomMenu": [menuItem.delete]} : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.transactionId){
					this.fn_edit();
				}
				else if(menuAction=='cancel'){
					// this.fn_cancelTransaction(this.displayData.transactionId, 'display');
					this.actionType = 'cancel';
					this.confirmationDialogHeader = "Cancel Transaction?";
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='delete'){
					this.actionType = 'delete';
					this.confirmationDialogHeader = "Delete Transaction?";
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='share'){
					// this.fn_shareInvoice('share');
					this.fn_bindInvoiceTemplate('share');
				}
			},

			fn_edit: function () {
				this.$router.push({path:'/transactions/inventory/stockjournal/items/'+this.displayData.transactionId+'/edit'});
			},

			fn_closeDialog: function(){
				this.$refs['ref_dialogPermission'].dialog_permission = false;
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			// fn_getPrintData: function(){
			// 	var self = this;
		 //  		this.getData('StockJournalPrintData', this.displayData.transactionId, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	self.printData = JSON.parse(response);
			// 	          	setTimeout(function(){
			// 	          		self.$refs['ref_printTemplate'].fn_init();
			// 	          	},300);
			// 	        }, 
			// 	        onError: function(error){
			// 	        	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },
		},
		mounted: function(){

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_showWebView();
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_getData('TransactionProducts', this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation || this.$refs['ref_dialogPermission'].dialog_permission){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				this.$refs['ref_dialogPermission'].dialog_permission = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
		// computed:{
		// 	transactionNumber: function () {
		// 		let prefix = this.displayData.prefix ? this.displayData.prefix + '/' : '';
	 //    		let suffix = this.displayData.suffix ? '/' + this.displayData.suffix : '';
	 //    		let transactionNumber = this.displayData.transactionNumber ? this.displayData.transactionNumber : '';
	 //    		return prefix + transactionNumber + suffix;
		// 	}
		// }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_journal/display.vue